import { render, staticRenderFns } from "./LicenciasClientes.vue?vue&type=template&id=571a045e&"
import script from "./LicenciasClientes.vue?vue&type=script&lang=js&"
export * from "./LicenciasClientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports